export default {
    'name': 'dragndrop',
    'width': '16',
    'height': '16',
    'viewBox': '0 0 16 16',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M3 12L2 11L11 2L12 3L3 12ZM7.5 13.5L6.5 12.5L12.5 6.5L13.5 7.5L7.5 13.5Z\' fill=\'#006CFD\'/>'
}
